import { NAV_LINKS, TID } from "@/constants/site";
import LogoMark from "@/components/LogoMark";

const Footer = () => {
  const go = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  const year = new Date().getFullYear();

  return (
    <footer className="relative border-t border-black/10 bg-[#EDF8F8] pt-20 pb-10">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-6">
            <div className="flex items-center gap-2.5">
              <LogoMark className="h-11 w-11" />
              <span className="font-display text-4xl sm:text-5xl font-extrabold tracking-tight text-[#0B2429] leading-none">
                aida<span className="text-[#43B0CE]">nova</span>
              </span>
            </div>
            <p className="mt-6 max-w-md font-quote text-lg leading-relaxed text-[#3C5156]">
              Smarter decisions for people. Practical AI for business.
            </p>
          </div>

          <div className="lg:col-span-3">
            <p className="font-mono-ed text-[10px] tracking-[0.2em] uppercase text-[#64787E]">Navigate</p>
            <ul className="mt-4 space-y-2.5">
              {NAV_LINKS.map((l) => (
                <li key={l.id}>
                  <button data-testid={TID.footer.jump(l.id)} onClick={() => go(l.id)} className="text-sm text-[#3C5156] hover:text-[#7FD0E6] transition-colors">
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <p className="font-mono-ed text-[10px] tracking-[0.2em] uppercase text-[#64787E]">Company</p>
            <ul className="mt-4 space-y-2.5 text-sm text-[#64787E]">
              <li>Registered legal name — <span className="italic">coming soon</span></li>
              <li>Jurisdiction — <span className="italic">coming soon</span></li>
              <li>Official email — <span className="italic">coming soon</span></li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-6 border-t border-black/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-[#94A7AC]">© {year} AidaNova. All rights reserved.</p>
          <p className="text-xs text-[#94A7AC] font-mono-ed tracking-wider">AI in service of people — not the other way around.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
